export default {
    allDayEventTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    allDaySlot: {
        type: Boolean,
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    currentTimeMarker: {
        type: [Boolean, Object],
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    date: {
        type: Date,
        default: undefined
    }, 
    dateHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    editable: {
        type: [Boolean, Object],
        default: undefined
    }, 
    endTime: {
        type: Date,
        default: undefined
    }, 
    eventTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    footer: {
        type: [Boolean, Object],
        default: undefined
    }, 
    group: {
        type: Object,
        default: undefined
    }, 
    groupHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    height: {
        type: [Number, String],
        default: undefined
    }, 
    majorTick: {
        type: Number,
        default: undefined
    }, 
    majorTimeHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    max: {
        type: Date,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    min: {
        type: Date,
        default: undefined
    }, 
    minorTickCount: {
        type: Number,
        default: undefined
    }, 
    minorTimeHeaderTemplate: {
        type: [String, Function],
        default: undefined
    }, 
    mobile: {
        type: [Boolean, String],
        default: undefined
    }, 
    pdf: {
        type: Object,
        default: undefined
    }, 
    resources: {
        type: Array,
        default: undefined
    }, 
    selectable: {
        type: Boolean,
        default: undefined
    }, 
    showWorkHours: {
        type: Boolean,
        default: undefined
    }, 
    snap: Boolean, 
    startTime: {
        type: Date,
        default: undefined
    }, 
    timezone: {
        type: String,
        default: undefined
    }, 
    toolbar: {
        type: Array,
        default: undefined
    }, 
    views: {
        type: Array,
        default: undefined
    }, 
    width: {
        type: [Number, String],
        default: undefined
    }, 
    workDayStart: {
        type: Date,
        default: undefined
    }, 
    workDayEnd: {
        type: Date,
        default: undefined
    }, 
    workWeekStart: {
        type: Number,
        default: undefined
    }, 
    workWeekEnd: {
        type: Number,
        default: undefined
    }, 

    // Events
    add: {
        type: Function,
        default: undefined
    },  
    cancel: {
        type: Function,
        default: undefined
    },  
    change: {
        type: Function,
        default: undefined
    },  
    dataBinding: {
        type: Function,
        default: undefined
    },  
    dataBound: {
        type: Function,
        default: undefined
    },  
    edit: {
        type: Function,
        default: undefined
    },  
    moveStart: {
        type: Function,
        default: undefined
    },  
    move: {
        type: Function,
        default: undefined
    },  
    moveEnd: {
        type: Function,
        default: undefined
    },  
    navigate: {
        type: Function,
        default: undefined
    },  
    pdfExport: {
        type: Function,
        default: undefined
    },  
    remove: {
        type: Function,
        default: undefined
    },  
    resizeStart: {
        type: Function,
        default: undefined
    },  
    resize: {
        type: Function,
        default: undefined
    },  
    resizeEnd: {
        type: Function,
        default: undefined
    },  
    save: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/KendoScheduler/SchedulerProps.js